export default __webpack_public_path__ + "0a1132897c54571424914dc8955e7457.svg";